<script lang="ts">
  // do not remove the <script> as it is mandatory for svelte components to be read properly by the IDE -David
</script>

<a
  href="/convert-facebook"
  class="flex overflow-hidden justify-center items-center w-full font-semibold bg-white rounded border outline-none clickable border-ngray-200 focusable border-nxgray-500 text-16 text-primary hover:bg-nxgray-50 focus:outline-none">
  <div class="google-icon" />
  <div>Continue with Facebook</div>
</a>

<style>
  .google-icon {
    background-image: url("./images/facebook-logo.svg");
    background-repeat: no-repeat;
    background-position: center;
    width: 42px;
    height: 42px;
  }
</style>
